export default {
  data: () => ({
    translations: {
      coupons: {
        el: 'Διαθέσιμα Κουπόνια:',
        en: 'Available Coupons:',
        it: 'Coupon Disponibili',
      },
      dialogTitle: {
        el: 'Απόκτηση Κουπονιού',
        en: 'Coupon Claim',
        it: 'Richiesta di coupon',
      },
      dialogDescription: {
        el: 'Θέλετε να προxωρήσετε στην εξαργύρωση  του κουπονιού: ',
        en: 'Do you want to redeem this coupon: ',
        it: 'Vuoi riscattare questo coupon: ',
      },
      dialogDescription2: {
        el: ' για τον χρήστη?',
        en: ' for the user?',
        it: " per l'utente?",
      },
      verificationCode: {
        el: ' Κωδικός Επιβεβαίωσης',
        en: ' Verification Code',
        it: ' Codice di verifica',
      },
      verificationCodeDescription: {
        el: 'Συμπληρώστε τον Κωδικό Επιβεβαίωσης που έχει σταλεί με SMS  στον πελάτη',
        en: 'Fill in the Confirmation Code sent by SMS to the customer.',
        it: 'Compilare il codice di conferma inviato via SMS al cliente.',
      },
      required: {
        el: ' Υποχρεωτικό',
        en: ' Required',
        it: ' Richiesto',
      },
      oneIntChar: {
        el: 'Κάθε πεδίο πρέπει να έχει ακριβώς ΕΝΑΝ ακέραιο αριθμό',
        en: 'Each field should have exactly ONE integer number',
        it: 'Ogni campo deve avere esattamente UN numero intero',
      },
      timeOutError: {
        el: 'Λήξη χρόνου επιβεβαίωσης κωδικού.',
        en: 'Validation time out.',
        it: 'Time out di convalida',
      },
      cannotSentCodeError: {
        el: 'Δεν μπορεί να σταλεί κωδικός επαλήθευσης. Παρακαλώ, προσπαθήστε ξανά αργότερα',
        en: 'Cannot sent verification code. Please, try again later',
        it: 'Impossibile inviare il codice di verifica. Riprovare più tardi',
      },
      wrongCodeError: {
        el: 'Λάθος κωδικός. Παρακαλώ, δοκιμάστε ξανά',
        en: 'Wrong verification code. Please, try again',
        it: 'Codice di verifica errato. Per favore, riprova',
      },
      verificationSuccess: {
        el: 'Επιτυχής επαλήθευση. Το κουπόνι εξαργυρώθηκε',
        en: 'Verification Successful. Coupon redeemed',
        it: 'Verifica riuscita. Coupon riscattato',
      },
      title: {
        el: 'Τίτλος',
        en: 'Title',
        it: 'Titolo',
      },
      description: {
        el: 'Περιγραφή',
        en: 'Description',
        it: 'Descrizione',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      redeem: {
        el: 'Εξαργύρωση',
        en: 'Redeem',
        it: 'Riscatta',
      },
      gift_image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      loyalty_program: {
        el: 'Πρόγραμμα Πιστότητας',
        en: 'Loyalty Program',
        it: 'Programma di fedeltà',
      },
      showAllCoupons: {
        el: 'Δείτε όλα τα κουπόνια',
        en: 'Show all coupons',
        it: 'Mostra tutti i coupon',
      },
      showOnlyClaimable: {
        el: 'Δείξε μόνο εξαργυρώσιμα',
        en: 'Show only claimable',
        it: 'Mostra solo riscattabili',
      },
      viewGifts: {
        el: 'Δείτε μελλοντικά δώρα',
        en: 'View future gifts',
        it: 'Vedi regali futuri',
      },
      futureGiftsTitle: {
        el: 'Μελλοντικά Δώρα',
        en: 'Future Gifts',
        it: 'Regali futuri',
      },
      noFutureGifts: {
        el: 'Δεν υπάρχουν μελλοντικά δώρα',
        en: 'No future gifts',
        it: 'Nessun regalo futuro',
      },
      close: {
        el: 'Κλείσιμο',
        en: 'Close',
        it: 'Chiudi',
      },
      notEnoughPoints: {
        el: 'Δεν υπάρχουν αρκετοί πόντοι',
        en: 'Not enough points',
        it: 'Punti insufficienti',
      },
    },
  }),
};
